import { SleepTrackingCard } from "@/components/SleepTrackingCard";
import { useSleepTracking } from "@/hooks/useSleepTracking";

export const Recovery = () => {
  const { 
    sleepLogs, 
    logSleep, 
    getWeeklyAverage,
    getSleepTrend 
  } = useSleepTracking();

  const weeklyAverage = getWeeklyAverage();
  const sleepTrend = getSleepTrend();

  return (
    <div className="bg-gradient-bg pb-24">
      <div className="max-w-7xl mx-auto p-4 sm:p-6">
        <div className="text-center mb-6">
          <h1 className="text-xl sm:text-2xl font-normal text-foreground mb-2">
            RECOVERY
          </h1>
          <p className="text-sm sm:text-base text-muted-foreground">
            Track your sleep and recovery for optimal performance
          </p>
        </div>
        
        <SleepTrackingCard
          sleepLogs={sleepLogs}
          onLogSleep={logSleep}
          weeklyAverage={weeklyAverage}
          trend={sleepTrend as 'improving' | 'declining' | 'stable'}
        />
      </div>
    </div>
  );
};
